import { Pipe, PipeTransform } from '@angular/core';
import { Replacer } from '../types';

@Pipe({ name: 'truncateUrl', standalone: true })
export class TruncateUrlPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(removeParam.regex, removeParam.replace).replace(shortenPath.regex, shortenPath.replace);
  }
}

/**
 * www.vendasta.com/adsf/vasc/qwerdsasd/?env=demo&widgetId=4efefad9-fa3b-4c83-bc4a-acc1be376269
 * $1 www.vendasta.com/adsf/vasc/qwerdsasd/
 * $2 ?env=demo&widgetId=4efefad9-fa3b-4c83-bc4a-acc1be376269
 */
const removeParam: Replacer = {
  regex: />([^<?]*\/?)(\?[^<]+)?<\/a>/g,
  replace: '>$1</a>',
};

/**
 * https://www.vendasta.com/adsf/vasc/qwerdsasd/
 * $1 https://www.vendasta.com/
 * $2 https://
 * $3 https
 * $4 /adsf/vasc/
 * $5 /qwerdsasd
 */
const shortenPath: Replacer = {
  regex: />(((https|http):\/\/)?[^</?]+\/)([^<?]+)?(\/[^<?/]+)+\/?<\/a>/g,
  replace: '>$1...$5</a>',
};
